import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="review-gate"
//
// Gates the express review/sign step's "Send application" button: it stays disabled until EVERY
// confirmation checkbox is checked (the "complete and correct" one, plus any partner-specific
// agreements such as the Paytient refund confirmation) AND a signature has been drawn. The
// signature lives in the shared v2/sign partial (hidden #signature-svgbase64 field, populated by
// the signatures controller, which dispatches a "change" when the pad is drawn or cleared).
export default class extends Controller {
  static targets = ["confirm", "submit"]

  connect() {
    this.signatureField = document.getElementById("signature-svgbase64")
    this.boundUpdate = this.update.bind(this)
    if (this.signatureField) this.signatureField.addEventListener("change", this.boundUpdate)
    this.update()
  }

  disconnect() {
    if (this.signatureField) this.signatureField.removeEventListener("change", this.boundUpdate)
  }

  update() {
    const confirmed = this.hasConfirmTarget && this.confirmTargets.every((cb) => cb.checked)
    const signed = !!(this.signatureField && this.signatureField.value.trim())
    const ready = confirmed && signed
    this.submitTargets.forEach((btn) => {
      btn.disabled = !ready
      btn.classList.toggle("opacity-50", !ready)
      btn.classList.toggle("cursor-not-allowed", !ready)
    })
  }

  // Transfer the click to the (hidden) signature submit button, which runs the signatures
  // controller's onSubmit (re-validates the signature, then submits).
  send() {
    document.getElementById("signature-button")?.click()
  }
}
